import { useId } from "react";

export const STATUS_STYLE = {
  draft: "bg-secondary text-body border-border", submitted: "bg-info-50 text-info-700 border-info-200", in_review: "bg-highlight-50 text-highlight-700 border-highlight-200",
  approved: "bg-success-50 text-success-700 border-success-200", scheduled: "bg-accent-50 text-accent-700 border-accent-200", in_progress: "bg-warning-50 text-warning-800 border-warning-200",
  completed: "bg-brand-100 text-brand-900 border-brand-300", rejected: "bg-danger-50 text-danger-700 border-danger-200", cancelled: "bg-secondary text-body border-border line-through decoration-border-strong",
};
export const RISK_STYLE = { low: "bg-success-50 text-success-700 border-success-200", medium: "bg-warning-50 text-warning-800 border-warning-200", high: "bg-notice-50 text-notice-800 border-notice-200", critical: "bg-danger-50 text-danger-700 border-danger-200" };
export const SUPPORT_STYLE = { resistant: "bg-danger-50 text-danger-700 border-danger-200", neutral: "bg-warning-50 text-warning-800 border-warning-200", supportive: "bg-accent-50 text-accent-700 border-accent-200", champion: "bg-success-50 text-success-700 border-success-200" };

export const label = (s) => (s || "").replace(/_/g, " ");

export function Pill({ value, map = STATUS_STYLE, testid }) {
  return <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-bold capitalize ${map[value] || STATUS_STYLE.draft}`}>{label(value)}</span>;
}

export function PageHeader({ overline, title, sub, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        {overline && <div className="pp-overline">{overline}</div>}
        <h1 className="font-head text-3xl sm:text-4xl font-extrabold tracking-tight mt-1 text-foreground">{title}</h1>
        {sub && <p className="text-muted-foreground mt-1.5 text-sm sm:text-base">{sub}</p>}
      </div>
      {action}
    </div>
  );
}

export function Stat({ label: l, value, hint, tone = "", testid }) {
  return (
    <div className="pp-card p-5" data-testid={testid}>
      <div className="text-xs font-bold uppercase tracking-wide text-muted-foreground">{l}</div>
      <div className={`font-head text-3xl font-extrabold tracking-tight mt-2 ${tone}`}>{value ?? "—"}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
}

export function Field({ label: l, children, className = "", htmlFor, group = false }) {
  // Implicit label association by default; `htmlFor` when the first labelable descendant is not the control; `group` for button groups.
  const gid = useId();
  if (group) return <div className={className}><div role="group" aria-labelledby={gid} className="block"><span id={gid} className="pp-label">{l}</span>{children}</div></div>;
  if (htmlFor) return <div className={className}><label htmlFor={htmlFor} className="pp-label">{l}</label>{children}</div>;
  return <div className={className}><label className="block"><span className="pp-label">{l}</span>{children}</label></div>;
}

export function Empty({ text, testid, to, linkText }) {
  return (
    <div data-testid={testid} className="rounded-2xl border border-dashed border-border-strong p-8 text-center text-sm text-muted-foreground">
      <p className="max-w-md mx-auto leading-relaxed">{text}</p>
      {to && <div className="mt-3 text-xs font-bold"><a href={to} data-testid={`${testid}-link`} className="text-accent-700 hover:text-accent-900">{linkText || "Read how"}</a></div>}
    </div>
  );
}

export function Score({ value, max = 5 }) {
  return (
    <span className="inline-flex gap-0.5">{Array.from({ length: max }).map((_, i) => <span key={i} className={`w-2 h-2 rounded-full ${i < value ? "bg-accent-500" : "bg-border"}`} />)}</span>
  );
}

export const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "—");
